<div class="container-fluid page" *ngIf="selectedIndex === 1">
  <div class="d-flex page__box p-3 mt-2">Market Rate Updates</div>
  <div class="page__content shadow p-3">
    <div class="page__content-data">
      <div>
        <div class="example-header" style="margin-bottom: -36px">
          <div>
            <button type="button" style="bottom: -23px" (click)="showViews(2)" class="btn btn-primary">
              Add MarketRate Update
            </button>

            <button type="button" style="bottom: -23px" (click)="showViews(3)" class="btn btn-primary">
              Bulk Upload
            </button>
          </div>
          <div class="col-md-12 mat-elevation-z8">
            <mat-form-field>
              <input matInput (keyup)="filtername($event.target.value)" placeholder="Name" /> </mat-form-field>&nbsp;
            <mat-form-field>
              <input matInput placeholder="Role" /> </mat-form-field>&nbsp;
            <mat-form-field>
              <input matInput placeholder="Status" /> </mat-form-field>&nbsp;
            <mat-form-field>
              <input matInput [(ngModel)]="myDateValue" [matDatepicker]="fromdate" [max]="maxDate" #frmdate
                placeholder="Choose From Date" readonly />
              <mat-datepicker-toggle matSuffix [for]="fromdate"></mat-datepicker-toggle>
              <mat-datepicker #fromdate></mat-datepicker> </mat-form-field>&nbsp;
            <mat-form-field>
              <input matInput [(ngModel)]="toDate" [matDatepicker]="picker" placeholder="Choose To date" />
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker> </mat-form-field>&nbsp;
            <!-- <mat-form-field>
      <input matInput  placeholder="Location">
    </mat-form-field>&nbsp; -->
          </div>
          &nbsp;<br />
        </div>

        <div class="example-container mat-elevation-z8">
          <mat-table #table [dataSource]="dataSource">
            <!--- Note that these columns can be defined in any order.
                    The actual rendered columns are set as a property on the row definition" -->
            <!-- Position Column -->
            <ng-container matColumnDef="position">
              <mat-header-cell *matHeaderCellDef> No. </mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ element.position }}
              </mat-cell>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="Coconutname">
              <mat-header-cell *matHeaderCellDef>
                Coconut name
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ element.Coconutname }}
              </mat-cell>
            </ng-container>

            <!-- Weight Column -->
            <ng-container matColumnDef="Verity">
              <mat-header-cell *matHeaderCellDef> Verity </mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ element.Verity }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Cultivation">
              <mat-header-cell *matHeaderCellDef> Cultivation </mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ element.Cultivation }}
              </mat-cell>
            </ng-container>

            <!-- <ng-container matColumnDef="ToDate">
                <mat-header-cell *matHeaderCellDef> ToDate </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.toDate}} </mat-cell>
              </ng-container> -->

            <!-- Symbol Column -->
            <ng-container matColumnDef="ExpectedPrice">
              <mat-header-cell *matHeaderCellDef>
                Expected Price (perton)
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ element.ExpectedPrice }}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="Location">
              <mat-header-cell *matHeaderCellDef> Location </mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ element.Location }}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="DateOfPublished">
              <mat-header-cell *matHeaderCellDef>
                Date Of Published
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ element.DateOfPublished }}
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
          </mat-table>

          <mat-paginator [pageSizeOptions]="[5]" #paginator showFirstLastButtons aria-label="">
          </mat-paginator>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid page" *ngIf="selectedIndex === 2">
  <!-- <div class="container-fluid page"> -->
  <div class="d-flex page__box p-3 mt-2">
    <img src="./assets/arrow_logo.png" class="arrow" (click)="listPage()" />&nbsp; Add Market Rate Updates
  </div>
  <div class="example-header">
    <mat-card class="matCardForm">
      <mat-card-content class="pa-1">
        <form [formGroup]="marketrateform" (ngSubmit)="onSubmit()">
          <div class="fulllwidth">
            <mat-form-field>
              <input matInput readonly [value]="currentD" />
            </mat-form-field>

            <!-- <mat-form-field>
              <mat-select formControlName="MarketId" placeholder="Market Name" required>
                <mat-option *ngFor="let opt of marketdatalist" (click)="getMarketId(opt.marketID)"
                  [value]="opt.marketName">
                  {{opt.marketName}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="marketrateform.get('MarketId').hasError('required')">
                Please Select Market Name.
              </mat-error>
            </mat-form-field> -->

            <!-- //*************** pahse 2 Updated market name**************************** -->
            <div>
              <span>
                <mat-form-field style="width:70%">
                  <mat-select formControlName="MarketID" placeholder="Market Name" required>
                    <mat-option *ngFor="let opt of marketdatalist" (click)="getMarketId(opt.marketID)"
                      [value]="opt.marketID">
                      {{ opt.marketName }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="marketrateform.get('MarketID').hasError('required')">
                    Please Select Market Name.
                  </mat-error> </mat-form-field>&nbsp;&nbsp;

                <button class="add_button_new" style="width:25%" mat-raised-button color="primary" (click)="manageMarket()">
                  Manage Market</button>&nbsp;
              </span>
            </div>
            <!-- 
            *************************end of market rate ************************************** -->
            <!-- ***********************phase 2 crop market*********************************************************** -->
            <div>
              <span>
                <mat-form-field style="width:70%">
                  <mat-select placeholder="Crop" formControlName="cropId">
                    <mat-option *ngFor="let opt of cropDataList" (click)="getCropId(opt.cropId)" [value]="opt.cropId">
                      {{ opt.cropName }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="marketrateform.get('cropId').hasError('required')">
                    Please Select Crop Name.
                  </mat-error> </mat-form-field>&nbsp;&nbsp;

                <button class="add_button_new" style="width:25%" mat-raised-button color="primary" (click)="manageCrop()">
                  Manage Crop</button>&nbsp;
              </span>
            </div>

            <!-- ***********************End of crop market*********************************************************** -->
            <div style="padding-top: 1px">
              <span>
                <mat-form-field style="width:70%">
                  <mat-select [disabled]="productdatalist == null" formControlName="ProductTypeID"
                    placeholder="Product Type" required>
                    <mat-option *ngFor="let opt of productdatalist" (click)="getproductId(opt.productTypeCode)"
                      [value]="opt.productTypeCode">
                      {{ opt.productType }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="
                      marketrateform.get('ProductTypeID').hasError('required')
                    ">
                    Please Select Product Name.
                  </mat-error>
                </mat-form-field>
                &nbsp;&nbsp;
                <button [disabled]="productdatalist == null" style="width:25%" class="add_button_new" mat-raised-button color="primary"
                  (click)="manageProduct()">
                  Add Product</button>&nbsp;
              </span>
            </div>

            <div>
              <span>
                <mat-form-field style="width:70%">
                  <mat-select [disabled]="subProductDataList?.length == 0" formControlName="SubProductTypeID"
                    placeholder="Sub Product Type" required>
                    <mat-option *ngFor="let opt of subProductDataList" (click)="getsubproductId(opt.subProductTypeCode)"
                      [value]="opt.subProductTypeCode">
                      {{ opt.subProductTypeName }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="
                      marketrateform
                        .get('SubProductTypeID')
                        .hasError('required')
                    ">
                    Please Select Sub-Product Name.
                  </mat-error>
                </mat-form-field>
                &nbsp;&nbsp;
                <button [disabled]="productdatalist == null" style="width:25%" class="add_button_new" mat-raised-button color="primary"
                  (click)="manageSubProduct()">
                  Add Sub Product</button>&nbsp;
              </span>
            </div>
            <!-- *************************************************************** -->
            <div>
              <span>
                <mat-form-field style="width:70%">
                  <mat-select placeholder="Unit" required formControlName="unitID">
                    <mat-option *ngFor="let opt of unitDataList" (click)="getUnitId(opt.unitID)" [value]="opt.unitID">
                      {{ opt.unitName }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="marketrateform.get('unitID').hasError('required')">
                    Please Select Market Name.
                  </mat-error> </mat-form-field>&nbsp;&nbsp;

                <button class="add_button_new" style="width:25%" mat-raised-button color="primary" (click)="manageUnit()">
                  Manage Unit</button>&nbsp;
              </span>
            </div>
            <!-- ************************************************************************** -->
            <mat-form-field>
              <input type="text" required (input)="deleteInputStream($event)" formControlName="Rate"
                [ngClass]="{ 'is-invalid': submitted && f.Rate.errors }" matInput placeholder="Rate (INR / KG)" />

              <mat-error *ngIf="marketrateform.get('Rate').hasError('max')">
                Please Enter less Than 10000000.
              </mat-error>
              <mat-error *ngIf="marketrateform.get('Rate').hasError('min')">
                Please Enter More Than 0.
              </mat-error>
            </mat-form-field>

            <mat-form-field>
              <textarea type="text" formControlName="Remark" maxlength="100" rows="2" matInput placeholder="Remark">
                Type Remark text here (100 characters maximum)
              </textarea>
              <!-- <mat-error *ngIf="form.get('Remark').hasError('required')">
              </mat-error> -->
            </mat-form-field>

            <div *ngIf="requirederror">Please Enter Mandatory Fields</div>

            <div class="row">
              <div class="col-md-10"></div>
              <div class="col-md-2">
                <button mat-button type="submit" [disable]="disable" class="submitBtn">
                  Post
                </button>
              </div>
            </div>
          </div>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
  <!-- </div> -->
</div>

<!-- <div class="container-fluid page" *ngIf="selectedIndex===2">
  <div class="d-flex page__box p-3 mt-2">&nbsp;&nbsp;Add Market Rate Updates</div>
  <div class="page__content shadow p-3 pagealign">
    <div class="page__content-data">
      <div>
        <form [formGroup]="marketrateform" (ngSubmit)="onSubmit()">
          <div class="form-row">
            <div class="form-group col-md-6">
              <mat-form-field>
                <mat-select formControlName="MarketId" placeholder="Market Name" required>
                  <mat-option *ngFor="let opt of marketdatalist" (click)="getMarketId(opt.marketID)"
                    [value]="opt.marketName">
                    {{opt.marketName}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="marketrateform.get('MarketId').hasError('required')">
                  Please Select Market Name.
                </mat-error>
              </mat-form-field>&nbsp;&nbsp;&nbsp;

              <mat-form-field>
                <mat-select formControlName="ProductId" placeholder="Product Type" required>
                  <mat-option *ngFor="let opt of productdatalist" (click)="getproductId(opt)" [value]="opt.productType">
                    {{opt.productType}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="marketrateform.get('ProductId').hasError('required')">
                  Please Select Product Name.
                </mat-error>
              </mat-form-field>


              <mat-form-field>
                <mat-select formControlName="SubProductId" placeholder="Sub Product Type" required>
                  <mat-option *ngFor="let opt of subprodectfilterdata" (click)="getsubproductId(opt.subProductTypeCode)"
                    [value]="opt.subProductTypeName">
                    {{opt.subProductTypeName}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="marketrateform.get('ProductId').hasError('required')">
                  Please Select Sub-Product Name.
                </mat-error>
              </mat-form-field>&nbsp;&nbsp;&nbsp;


              <mat-form-field>
                <input type="text" required (input)="deleteInputStream($event)" formControlName="Rate"
                  [ngClass]="{ 'is-invalid': submitted && f.Rate.errors }" matInput placeholder="Rate (INR / KG)">
                
                <mat-error *ngIf="marketrateform.get('Rate').hasError('max')">
                  Please Enter less Than 10000000.
                </mat-error>
                <mat-error *ngIf="marketrateform.get('Rate').hasError('min')">
                  Please Enter More Than 0.
                </mat-error>
              </mat-form-field>
            </div>

          </div>
          <div *ngIf="requirederror">Please Enter Mandatory Fields</div>
          <button type="submit" [disable]="disable" style="left: 489px!important;top: -14px;"
            class="btn btn-primary">Post</button>
        </form>
      </div>
    </div>
  </div>
</div> -->

<div class="container-fluid page" *ngIf="selectedIndex === 3">
  <div class="d-flex page__box p-3 mt-2">
    &nbsp;&nbsp;Bulk Market Rate Updates
  </div>
  <div class="page__content shadow p-3 pagealign">
    <div class="page__content-data" style="top: 230px; left: 59%">
      <div>
        <button class="downloadbutt" (click)="downloadCSV()">
          <mat-icon>cloud_download</mat-icon>Download CSV file
        </button>
      </div>
    </div>
  </div>
</div>